var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import styles from './Checkbox.module.scss';
import { Checkmark, CheckmarkDark } from '../../assets/icons';
var Checkbox = React.memo(function Checkbox(_a) {
    var checked = _a.checked, marked = _a.marked, partial = _a.partial, disabled = _a.disabled, label = _a.label, className = _a.className, id = _a.id, dataId = _a.dataId, onChange = _a.onChange;
    var classes = "".concat(checked ? styles.Checked : '', " ").concat(partial ? styles.Partial : '', " ").concat(disabled ? styles.Disabled : '');
    var onCheckboxChange = function (e) {
        !disabled && onChange(!checked);
        e.stopPropagation();
    };
    return (_jsxs("div", __assign({ id: id, className: "".concat(styles.CheckboxContainer, " ").concat(className ? className : ''), onClick: onCheckboxChange }, { children: [_jsxs("span", __assign({ className: "".concat(styles.Checkbox, " ").concat(classes), "data-testid": dataId }, { children: [checked && _jsx(Checkmark, {}), marked && !checked && !partial && _jsx(CheckmarkDark, {}), partial && !checked && _jsx("span", { className: styles.PartialLine })] })), label && _jsx("label", __assign({ className: "".concat(styles.Label, " ").concat(disabled ? styles.LabelDisabled : '') }, { children: label }))] })));
});
Checkbox.propTypes = {
    checked: PropTypes.bool.isRequired,
    marked: PropTypes.bool,
    partial: PropTypes.bool,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    className: PropTypes.string,
    id: PropTypes.string,
    dataId: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};
Checkbox.defaultProps = {
    checked: false,
    className: '',
};
export { Checkbox };
//# sourceMappingURL=Checkbox.js.map